import { render } from "./UiUxStrategy.vue?vue&type=template&id=2e47379e&scoped=true&ts=true"
import script from "./UiUxStrategy.vue?vue&type=script&lang=ts"
export * from "./UiUxStrategy.vue?vue&type=script&lang=ts"

import "./UiUxStrategy.vue?vue&type=style&index=0&id=2e47379e&scoped=true&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e47379e"]])

export default __exports__